import { render, staticRenderFns } from "./trade-data.vue?vue&type=template&id=12b8c878"
import script from "./trade-data.vue?vue&type=script&lang=js"
export * from "./trade-data.vue?vue&type=script&lang=js"
import style0 from "./trade-data.vue?vue&type=style&index=0&id=12b8c878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports